import { Controller } from "stimulus"
import _each from 'lodash/each'

export default class extends Controller
  @targets: [
    'videoChatServiceSelect',
    'videoChatServiceOtherFields',
  ]

  initialize: ->
    @render()
    
  render: ->
    if @hasVideoChatServiceSelectTarget
      videoChatService = @videoChatServiceSelectTarget.selectedOptions[0].text
      @videoChatServiceOtherFieldsTarget.classList.toggle("hidden", videoChatService != "Other")